import { Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { FastLaneRequest } from '../models/fastlane.model';
import { BackButtonComponent } from '../../shared/components/back-button/back-button.component';

@Component({
	selector: 'copo-fastlane',
	styleUrl: './fastlane.component.css',
	templateUrl: './fastlane.component.html',
	imports: [BackButtonComponent, TranslateModule]
})
export class FastLaneComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	user: User;
	fastLaneRequest!: FastLaneRequest;
	isLoading = true;

	constructor(
		private readonly userService: UserService
	) {
		this.user = this.userService.user;
	}
}
